import { useMemo } from "react";
import { UseRequestPastProposalsProps } from "@companion-core/shared/app/Components/Requests/RequestDetail/RequestPastRecommendations/requestPastRecommendations.model";
import { useProposals } from "@companion-core/shared/app/Queries";
import { APIProposal } from "@companion-core/shared/app/Interfaces/API";
import { useTranslation } from "react-i18next";

export const useRequestPastProposals = ({ requestData }: UseRequestPastProposalsProps) => {
  const { t } = useTranslation();
  const { data: proposalsData, isPending: isGetProposalsPending } = useProposals(requestData.id);
  const proposals = useMemo(
    () =>
      (proposalsData?.data?.results?.filter(
        (value: APIProposal) => value.status !== "generated" && value.status !== "draft"
      ) ?? []) as APIProposal[],
    [proposalsData]
  );

  return {
    t,
    isGetProposalsPending,
    proposals,
  };
};
